module.exports = __webpack_public_path__ + "img/zhufengliang.799ae408.jpg";